<app-modal-header [title]="'Assignment code'"></app-modal-header>
<div class="modal-body px-7 pb-7 pt-0">
    <div class="description mb-6">
        Using this Quick Assign code in the link, students can complete the assignment without
        signing in. They will be prompted to enter their name and their submitted work will be
        available under “Quick Assign.”
    </div>

    <app-copy-link class="mb-6 d-inline-block" [shareLink]="shareLink"></app-copy-link>
    <div class="d-flex justify-content-end">
        <button class="btn btn-outline-secondary" (click)="activeModal.close()">Cancel</button>
    </div>
</div>
